import { useContext, useState } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Context from "../Contex/Context";

const ApiScreen = () => {
  const [showApiKey, setShowApiKey] = useState(true);
  const { api_keyValue } = useContext(Context);

  const openEye = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="lucide lucide-eye"
    >
      <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );

  const closeEye = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="lucide lucide-eye-off"
    >
      <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24" />
      <path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68" />
      <path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61" />
      <line x1="2" x2="22" y1="2" y2="22" />
    </svg>
  );
  return (
    <div
      style={{
        padding: "20px",
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          padding: "16px",
          boxShadow: "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
          borderRadius: "4PX",
          display: "flex",
          flexDirection: "column",
          gap: "20px",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
            }}
          >
            <h1
              style={{
                lineHeight: "20px",
                color: "#393939",
                fontFamily: "Source Sans 3",
                fontSize: "18px",
                fontStyle: "normal",
                fontWeight: 700,
              }}
            >
              API Documentation
            </h1>
          </div>
          <p
            style={{
              lineHeight: "18px",
              color: "#868686",
              fontFamily: "Source Sans 3",
              fontStyle: "normal",
              fontSize: "12px",
              fontWeight: 400,
            }}
          >
            You can automate your work with Riffy.io tools and integrate them
            with your apps and tools using our REST API. To access API
            credentials, upgrade your plan or try it for free by emailing us at{" "}
            <span
              style={{
                color: "#1C485F",
                ontFamily: "Source Sans 3",
                fontSize: "12px",
                fontStyle: "normal",
                fontWeight: 400,
              }}
            >
              coldsender.com
            </span>{" "}
            with your request. Read more about API here.
            <span
              style={{
                color: "#1C485F",
                fontFamily: "Source Sans 3",
                fontStyle: "normal",
                fontSize: "12px",
                fontWeight: 400,
              }}
            >
              here
            </span>
          </p>
        </div>
        <div style={{ display: "flex", gap: "12px" }}>
          <Link to="/api/documentation">
            <button
              style={{
                padding: "8px 16px",
                backgroundColor: "transparant",
                color: "#1C485F",
                fontFamily: "Source Sans 3",
                fontStyle: "normal",
                fontSize: "12px",
                fontWeight: 400,
                outline: "none",
                border: "1px solid #1C485F",
                borderRadius: "4px",
              }}
            >
              View Api Documentation
            </button>
          </Link>
          <a
            href="mailto:support@coldsender.com"
            target="_blank"
            style={{
              textDecoration: "none",
              padding: "8px 16px",
              backgroundColor: "#D1DFE9",
              color: "#1C485F",
              fontFamily: "Source Sans 3",
              fontStyle: "normal",
              fontSize: "12px",
              fontWeight: 400,
              outline: "none",
              borderRadius: "4px",
            }}
          >
            Contact us
          </a>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            gap: "5px",
            flexDirection: "column",
          }}
        >
          <h1
            style={{
              lineHeight: "20px",
              color: "#393939",
              fontFamily: "Source Sans 3",
              fontSize: "16px",
              fontStyle: "normal",
              fontWeight: 600,
            }}
          >
            API Key
          </h1>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "#FAFAFA",
              border: "1px solid #1C485F",
              borderRadius: "4px",
              padding: "0px 6px",
            }}
          >
            <input
              type="text"
              value={
                showApiKey ? "*".repeat(api_keyValue.length) : api_keyValue
              }
              style={{
                backgroundColor: "transparent",
                outline: "none",
                padding: "8px 6px",
                display: "flex",
                alignItems: "center",
              }}
            />
            <button
              style={{ outline: "none" }}
              onClick={() => {
                setShowApiKey(!showApiKey);
              }}
            >
              {showApiKey ? openEye : closeEye}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApiScreen;
